export const westvirginiaCountiesList = [
    'Barbour',
    'Berkeley',
    'Boone',
    'Braxton',
    'Brooke',
    'Cabell',
    'Calhoun',
    'Clay',
    'Doddridge',
    'Fayette',
    'Gilmer',
    'Grant',
    'Greenbrier',
    'Hampshire',
    'Hancock',
    'Hardy',
    'Harrison',
    'Jackson',
    'Jefferson',
    'Kanawha',
    'Lewis',
    'Lincoln',
    'Logan',
    'McDowell',
    'Marion',
    'Marshall',
    'Mason',
    'Mercer',
    'Mineral',
    'Mingo',
    'Monongalia',
    'Monroe',
    'Morgan',
    'Nicholas',
    'Ohio',
    'Pendleton',
    'Pleasants',
    'Pocahontas',
    'Preston',
    'Putnam',
    'Raleigh',
    'Randolph',
    'Ritchie',
    'Roane',
    'Summers',
    'Taylor',
    'Tucker',
    'Tyler',
    'Upshur',
    'Wayne',
    'Webster',
    'Wetzel',
    'Wirt',
    'Wood',
    'Wyoming',
    ]